import { render, staticRenderFns } from "./MinIndex.vue?vue&type=template&id=57c68067&scoped=true&"
import script from "./MinIndex.vue?vue&type=script&lang=js&"
export * from "./MinIndex.vue?vue&type=script&lang=js&"
import style0 from "./MinIndex.vue?vue&type=style&index=0&id=57c68067&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c68067",
  null
  
)

export default component.exports